// src/auth/protected-route.js
import React, { useEffect } from "react";
import { Route } from "react-router-dom";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import Loader from "../components/Loader";

const PrivateRoute = ({ component, ...args }) => {

  return (
    <Route
      component={withAuthenticationRequired(component, {
        onRedirecting: () => <Loader />,
      })}
      {...args}
    />
  );
};

export default PrivateRoute;
